import React, { useEffect, useState } from 'react';
import { Paper, Typography, Box, Avatar, IconButton, Button, Link } from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import BrandSideLogo from '@/components/BrandSideLogo';
import vendorService from "@/service/vender.service";
import ToastService from '@/service/toaster.service';

export default function UploadProfileImage() {
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // ✅ Get vendorId from Redux store
  const vendorId = useSelector((state) => state.auth.auth.id);
  useEffect(() => {
    const inProgress = localStorage.getItem("in_progress_onboarding");
    if (!inProgress) {
      navigate("/vendor/dashboard");
    }
  }, []);
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleImageUpload = async () => {
    if (!image || !vendorId) return;
  
    setLoading(true);
  
    try {
      const formData = new FormData();
      
      // Append the file as 'profile_picture'
      formData.append("profile_picture", image); // Ensure this is a File object
      
      // Log FormData entries to verify the content
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }
  
      // Send request to the backend
      await vendorService.updateVendorProfile(vendorId, formData);
      localStorage.removeItem("in_progress_onboarding");
      ToastService.success("Profile Picture Uploaded Successfully");
      navigate('/vendor/onboarding/profile-wizard');
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Upload error:", error);
    } finally {
      setLoading(false);
    }
  };

  const skipProfileImage = () => {
    localStorage.removeItem("in_progress_onboarding");
    navigate('/vendor/onboarding/profile-wizard');
  };

  return (
    <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} width="100%" height="100vh">
      {/* Left side */}
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        flex="1"
        bgcolor="primary.main"
        color="white"
        width="100%"
      >
        <BrandSideLogo />
      </Box>

      {/* Right side */}
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        flex="1"
        bgcolor="background.default"
      >
        <ToastContainer />
        <Paper elevation={5} sx={{ p: 4, maxWidth: 400, width: "100%" }}>
          <Typography variant="h5" mb={3} color="#5E5ACF" fontWeight="bold" align="center">
            Upload Picture
          </Typography>

          <Box mt={5} mb={2} textAlign="center">
            <Avatar
              src={previewUrl}
              alt="Profile"
              sx={{
                width: 120,
                height: 120,
                margin: "0 auto",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            />
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="label"
              sx={{ mt: 1 }}
            >
              <input
                hidden
                accept="image/*"
                type="file"
                onChange={handleImageChange}
              />
              <PhotoCamera />
            </IconButton>
          </Box>

          <Button
            variant="contained"
            fullWidth
            sx={{
              mt: 5,
              color: "black",
              fontWeight: 'bold',
              bgcolor: "rgba(242, 190, 34, 0.94)",
              "&:hover": { bgcolor: "#5E5ACF" }
            }}
            onClick={handleImageUpload}
            disabled={!image || !vendorId || loading}
          >
            {loading ? "Uploading..." : "Upload"}
          </Button>

          <Typography
            variant="body2"
            color="primary"
            sx={{ cursor: "pointer", mt: 2, textAlign: 'center' }}
          >
            <Link onClick={skipProfileImage}>Skip</Link>
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}
